import {
    PUSH_TOKEN, RESET_TOKEN,
    //PUSH_USER_DATA_ERROR
} from "../actions/types";

const INIT_STATE = {
    token : ""
}

const cmsAuthReducer = function (state=INIT_STATE, action) {
    const {type, payload } = action;
    switch (type) {
        case PUSH_TOKEN:
            return {
                ...state,
                token:payload
            }
        case RESET_TOKEN:        
            return {
                ...state,
                token: ""
            } 
        default:
            return state;    
    }
};

export default cmsAuthReducer;